import React from 'react';
import { Card } from '../../components/ui/Card';
export function Checkout() {
  return <div className="space-y-4 max-w-3xl" data-id="element-1676">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1677">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1678">
          Checkout
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1679">
          Complete your purchase to begin your courses.
        </p>
      </div>
      <div className="rounded-xl p-6 space-y-4" style={{
      backgroundColor: '#FDF6E3'
    }} data-id="element-1680">
        <p className="text-sm text-slate-600" data-id="element-1681">Your cart is now empty</p>

        {/* Contact Information */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1682">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1683">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1684">
              Contact Information
            </h2>
          </div>
          <div className="p-0" data-id="element-1685">
            <table className="w-full text-sm" data-id="element-1686">
              <tbody className="divide-y divide-slate-200" data-id="element-1687">
                {[{
                label: 'First Name :',
                value: 'Dana'
              }, {
                label: 'Last Name :',
                value: 'Kichen'
              }, {
                label: 'Company :',
                value: ''
              }, {
                label: 'Phone :',
                value: '4803910222'
              }, {
                label: 'Fax :',
                value: ''
              }, {
                label: 'Website :',
                value: ''
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1688">
                    <td className="px-3 py-1.5 text-slate-600 w-32 bg-slate-50" data-id="element-1689">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1690">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1691" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Billing Address */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1692">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1693">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1694">
              Billing Address
            </h2>
          </div>
          <div className="p-0" data-id="element-1695">
            <table className="w-full text-sm" data-id="element-1696">
              <tbody className="divide-y divide-slate-200" data-id="element-1697">
                {[{
                label: 'Address :',
                value: '14793 N. 90th Place'
              }, {
                label: 'City :',
                value: 'Scottsdale'
              }, {
                label: 'State :',
                value: 'AZ'
              }, {
                label: 'Zip/Postal Code :',
                value: '85260'
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1698">
                    <td className="px-3 py-1.5 text-slate-600 w-36 bg-slate-50" data-id="element-1699">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1700">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1701" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Update button */}
        <div data-id="element-1702">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1703">
            Update
          </button>
        </div>

        {/* Credit Card Section */}
        <div className="space-y-3 text-sm" data-id="element-1704">
          <div className="flex items-end gap-4 flex-wrap" data-id="element-1705">
            <div data-id="element-1706">
              <label className="block text-slate-700 mb-1" data-id="element-1707">
                Credit Card Number
              </label>
              <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-44 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1708" />
            </div>
            <div data-id="element-1709">
              <label className="block text-slate-700 mb-1" data-id="element-1710">Exp.</label>
              <div className="flex gap-1" data-id="element-1711">
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1712">
                  {['Month', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(m => <option key={m} data-id="element-1713">{m}</option>)}
                </select>
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1714">
                  {['Year', '2025', '2026', '2027', '2028', '2029', '2030'].map(y => <option key={y} data-id="element-1715">{y}</option>)}
                </select>
              </div>
            </div>
            <div data-id="element-1716">
              <label className="block text-slate-700 mb-1" data-id="element-1717">CCV</label>
              <div className="flex items-center gap-1" data-id="element-1718">
                <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-16 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1719" />
                <div className="w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center font-bold cursor-help" title="The 3-digit security code on the back of your card" data-id="element-1720">
                  ?
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1721">
            <div className="flex-1 min-w-32" data-id="element-1722">
              <label className="block text-slate-700 mb-1" data-id="element-1723">First Name</label>
              <input type="text" defaultValue="Dana" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1724" />
            </div>
            <div className="flex-1 min-w-32" data-id="element-1725">
              <label className="block text-slate-700 mb-1" data-id="element-1726">Last Name</label>
              <input type="text" defaultValue="Kichen" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1727" />
            </div>
          </div>

          <div data-id="element-1728">
            <label className="block text-slate-700 mb-1" data-id="element-1729">Email</label>
            <input type="email" defaultValue="reggieborris@yahoo.com" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1730" />
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1731">
            <div className="flex-1 min-w-40" data-id="element-1732">
              <label className="block text-slate-700 mb-1" data-id="element-1733">Address</label>
              <input type="text" defaultValue="14793 N. 90th Place" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1734" />
            </div>
            <div className="flex-1 min-w-28" data-id="element-1735">
              <label className="block text-slate-700 mb-1" data-id="element-1736">City</label>
              <input type="text" defaultValue="Scottsdale" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1737" />
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1738">
            <div className="w-16" data-id="element-1739">
              <label className="block text-slate-700 mb-1" data-id="element-1740">State</label>
              <input type="text" defaultValue="AZ" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1741" />
            </div>
            <div className="w-24" data-id="element-1742">
              <label className="block text-slate-700 mb-1" data-id="element-1743">Zip Code</label>
              <input type="text" defaultValue="85260" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1744" />
            </div>
            <div className="w-24" data-id="element-1745">
              <label className="block text-slate-700 mb-1" data-id="element-1746">Country</label>
              <input type="text" defaultValue="US" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1747" />
            </div>
          </div>

          <div className="flex gap-6 items-start" data-id="element-1748">
            <div className="flex-1" data-id="element-1749">
              <label className="block text-slate-700 mb-1" data-id="element-1750">
                Customer Notes
              </label>
              <textarea rows={4} className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1751" />
            </div>
            <div className="text-center pt-4" data-id="element-1752">
              <p className="text-xs text-slate-600 mb-1" data-id="element-1753">
                Credit Card Processing
              </p>
              <div className="w-16 h-16 border border-slate-300 rounded flex items-center justify-center bg-slate-50" data-id="element-1754">
                <span className="text-xs text-slate-400 text-center leading-tight" data-id="element-1755">
                  Authorize.Net
                </span>
              </div>
              <button className="mt-1 text-xs text-blue-600 hover:underline" data-id="element-1756">
                Credit Card Processing
              </button>
            </div>
          </div>
        </div>

        {/* Buy button */}
        <div className="flex items-center gap-3" data-id="element-1757">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1758">
            Buy
          </button>
          <span className="text-sm font-medium" style={{
          color: '#CC0000'
        }} data-id="element-1759">
            Please click BUY button only ONCE to avoid a duplicate order
          </span>
        </div>
      </div>
    </div>;
}